export default "__VITE_ASSET__C1kCi3xo__"